import { Mixpanel } from '../../../services/Mixpanel';
import { SidebarCard } from './SidebarCard';

/**
 * The two plain-message cards in AppSidebar's bottom slot: a welcome callout,
 * and a "you're on classic" notice carrying the link back to the new experience.
 *
 * Presentational only. Which variant shows, whether it shows at all, and which
 * nux key its dismissal writes are all the slot's business — see
 * useSidebarCardLadder. Holding those here meant the card could win the slot
 * while having nothing to render, which starves every card below it.
 */
export const SidebarMessage = ({ variant, onDismiss }) => (
  <SidebarCard onDismiss={onDismiss}>
    {variant === 'classic' ? (
      <>
        <p className='text-2xl mb-1'>👋</p>
        <p className='text-base font-medium text-gray-900 mb-5'>You&apos;re using Classic Diffit</p>
        <p className='text-sm text-gray-500 leading-relaxed font-light'>
          Switch back to{' '}
          <a
            href='/'
            onClick={() => {
              Mixpanel.track('New Version Clicked');
              sessionStorage.removeItem('preferClassic');
            }}
            className='text-emerald-700 underline hover:text-emerald-800'>
            the new Diffit experience
          </a>{' '}
          anytime.
        </p>
      </>
    ) : (
      <>
        <p className='text-2xl mb-1'>👋</p>
        <p className='text-base font-medium text-gray-900 mb-5'>Welcome to Diffit!</p>
        <p className='text-sm text-gray-500 leading-relaxed font-light'>
          Teachers use Diffit to save time and help all students access grade-level content.
        </p>
      </>
    )}
  </SidebarCard>
);

export default SidebarMessage;
